export default {
  GOALS_TITLE: 'Goals',
  ACTIVITY_TITLE: 'Activity',
  RECENTLY_VIEWED_TITLE: 'Recently Viewed',
  DONOR_WEEKLY_GOAL: 'Your Weekly Goal',
  DONOR_MONTHLY_GOAL: 'Your Monthly Goal',
  DAILY_SIGN_IN_STREAK: 'Daily Sign in Streak',
  DAILY_SIGN_IN_STREAK_UNITS: 'Days',
  HOME: 'Home',
  VISIT_STREAK: 'Visit Streak',
  ERROR_UPDATING_ORG_INFO: 'Error updating org info',
  ADD_ANNOUNCEMENT: 'Add Announcement',
  ADD_GLOBAL_ANNOUNCEMENT: 'Add Global Announcement',
  A2HS_ADD_TO_HOME_SCREEN: 'Add to Home Screen',
  A2HS_TAP_ON_ICON: 'Tap on the share icon',
  A2HS_SELECT: 'Select <strong>Add to Home Screen</strong>',
};
